var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VJsoneditor',{attrs:{"height":'500px',"options":{
    search: false,
    mode: 'code',
    indentation: 2,
  }},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})}
var staticRenderFns = []

export { render, staticRenderFns }